<template>
    <div>

        <!-- Table -->

        <trax-ui-card-plain-header-with-actions :title="title" :actions="card_actions" :bus="bus">
            <trax-setting-task-crud-table :bus="bus" :id="id" :endpoint="endpoint">
            </trax-setting-task-crud-table>
        </trax-ui-card-plain-header-with-actions>

        <!-- Cancellation confirmation -->

        <trax-ui-modal-confirm :id="id+'-cancel'" :title="lang.polaris.settings.task_cancellation" :bus="bus">
            {{ lang.polaris.settings.confirm_cancel_task_q }}
        </trax-ui-modal-confirm>

        <!-- Search modal -->

        <trax-ui-modal-default :id="id+'-search'" :bus="bus" :title="lang.polaris.form.advanced_search">
            <trax-setting-task-crud-search :id="id" :bus="bus"></trax-setting-task-crud-search>
        </trax-ui-modal-default>

        <!-- History cleaning modal -->

        <trax-ui-modal-default :id="id+'-delete-tasks'" :bus="bus" :title="lang.polaris.settings.tasks_deletion">
            <trax-setting-task-crud-delete :id="id" :bus="bus"></trax-setting-task-crud-delete>
        </trax-ui-modal-default>

        <!-- Toastr -->

        <trax-ui-toastr :id="id+'-toastr'" :bus="bus" passed-label="1" no-progress="1">
        </trax-ui-toastr>

    </div>
</template>

<script>
    export default {

        props: {
            id: null
        },

        data: function() {
            return {
                lang: lang,
                app_url: app_url,

                // The learner, their program and the consumer who asked for it are shown on each row.
                endpoint: app_url+"polaris/api/front/tasks"
                    +"?relations[]=user&relations[]=requester&relations[]=registration.program",
                card_actions: [
                    { icon: 'delete', event: this.id+'-delete-tasks-open' },
                    { icon: 'refresh', event: this.id+'-refresh' },
                    { icon: 'search', event: this.id+'-search-open' }
                ],
                bus: new Vue()
            }
        },

        computed: {

            title() {
                return this.lang.polaris.settings.tasks;
            }
        },

        created: function() {
            this.bus.$on(this.id+'-cancel-confirmed', this.cancel);
            this.bus.$on(this.id+'-delete-tasks-confirmed', this.deleteTasks);
        },

        methods: {

            deleteTasks(statuses) {
                var that = this;
                axios.delete(this.app_url+'polaris/api/front/tasks', {data: {statuses: statuses}})
                    .then(function (response) {
                        that.bus.$emit(that.id+'-refresh');
                    })
                    .catch(function (error) {
                        that.bus.$emit(that.id+'-toastr-error', error.response.data);
                    });
            },

            // The process is not killed: a running task stops at its next checkpoint, so the row
            // may stay in a cancelling state for a while.
            cancel(task) {
                var that = this;
                axios.post(this.app_url+'polaris/api/front/tasks/'+task.id+'/cancel')
                    .then(function (response) {
                        that.bus.$emit(that.id+'-refresh');
                    })
                    .catch(function (error) {
                        that.bus.$emit(that.id+'-toastr-error', error.response.data);
                    });
            }
        }

    }
</script>
